module.exports = __webpack_public_path__ + "static/media/mobileLandscapeExample.374b65d7.png";